export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DashboardGeneral.vue?vue&type=template&id=8a28a780&"


//////////////////
// WEBPACK FOOTER
// ./src/views/dashboard/DashboardGeneral.vue?vue&type=template&id=8a28a780&
// module id = 977
// module chunks = 0